import React from 'react';

import { Box, Typography } from '@mui/material';
import AuditOperationCell from 'app/shared/modules/EntityAuditHistory/components/AuditOperationCell';
import { formatRowDateTime } from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.utils';
import PropTypes from 'prop-types';

import { versionOptionStyles } from './VersionOption.styles';

/** A listed change in the version picker: when, what it did, and its scope chips. */
const VersionOption = ({ option }) => (
  <Box sx={versionOptionStyles}>
    <Typography variant="regular14">{formatRowDateTime(option.occurredAtUtc)}</Typography>
    <AuditOperationCell chips={option.chips} summary={option} />
  </Box>
);

VersionOption.propTypes = {
  option: PropTypes.shape({
    occurredAtUtc: PropTypes.string,
    operation: PropTypes.string,
    chips: PropTypes.arrayOf(PropTypes.node),
  }).isRequired,
};

export default VersionOption;
